import React from 'react';
import { DegreeCard } from './DegreeCard';
import { degreeCategories } from '../data/degrees';
export function DegreeCategoryGrid() {
  return <section className="w-full bg-background-alt py-14 md:py-20" data-id="element-145" data-mp="110qc7x7sks21">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-146" data-mp="w26ru18ujobs">
        <div className="text-center mb-12 max-w-2xl mx-auto" data-id="element-147" data-mp="s1d1z2bufzg9">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4" data-id="element-148" data-mp="s2xwwt22lken">
            Explore Popular Degree Categories
          </h2>
          <p className="text-base md:text-lg text-ink-secondary leading-relaxed" data-id="element-149" data-mp="1jsj5ztuoqhat">
            Browse programs by field of study to find the right path for your
            career goals. Every partner school is fully accredited — meaning
            it's been independently reviewed for quality.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-150" data-mp="27ina02bscj2c">
          {degreeCategories.map(category => <DegreeCard key={category.id} category={category} data-id="element-151" data-mp="22qc9ax980t8q" />)}
        </div>
      </div>
    </section>;
}